import { Table } from "antd"
import { useContext } from "react"
import { ItemsContext } from "../../Items/ItemsRoot"
import dayjs from 'dayjs'
import { centsToDollarsDisplay } from "../../displayFormatters"
import { Action } from "./createInvoiceReducer"
import { getBillablePerVisitAmounts, InvoiceWorkareaGroup } from "./createInvoiceModel"

type Props = {
  group: InvoiceWorkareaGroup
  dispatch: (action: Action) => void
}
const VisitSelector = ({ group, dispatch }: Props) => {
  const { jobData: { visitData } } = useContext(ItemsContext)
  const selections = getBillablePerVisitAmounts(visitData, group.completedVisits)

  const handleSelect = (selectedVisitIds: string[]) => {
    dispatch({ type: 'SELECTED_VISITS_CHANGED', groupId: group.id, selectedVisitIds })
  }

  return <Table
    size="small"
    dataSource={selections}
    columns={[
      {
        title: 'Visit Date',
        render: (_, x) => dayjs(x.date).format('MMM D, YYYY')
      },
      {
        title: 'Price',
        render: (_, x) => centsToDollarsDisplay(x.visitPrice)
      }
    ]}
    rowKey="visitId"
    rowSelection={{
      selectedRowKeys: group.selectedVisitIds,
      onChange: (keys) => handleSelect(keys as string[])
    }}
  />
}

export default VisitSelector
